import React from "react";
import SEO from "@/components/SEO";
import LeadForm from "@/components/LeadForm";
import { useSettings } from "@/context/SettingsContext";
import { Phone, Mail, MapPin, Clock, MessageCircle } from "lucide-react";

export default function Contact() {
  const { settings, waLink, telLink } = useSettings();
  const s = settings || {};
  const mapSrc = `https://www.google.com/maps?q=${encodeURIComponent(s.map_embed_query || "Bangalore, Karnataka")}&output=embed`;
  return (
    <div>
      <SEO title="Contact Mathura Homes | Property Consultant in Bangalore" description="Get in touch with Mathura Homes. Call, WhatsApp or email us, or book a free consultation for your property search in Bangalore." />
      <section className="bg-navy py-20 text-center">
        <div className="max-w-3xl mx-auto px-4">
          <span className="inline-block h-1 w-16 bg-gold mb-6" />
          <h1 className="font-display text-4xl md:text-5xl text-white">Get In Touch</h1>
          <p className="text-gray-300 mt-5">We're here to help you find your perfect property. Reach out anytime.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid lg:grid-cols-2 gap-12">
        <div className="space-y-6">
          <div className="grid sm:grid-cols-2 gap-4">
            <a href={telLink()} data-testid="contact-call" className="p-6 rounded-2xl bg-white border border-gray-100 shadow-card hover:shadow-card-hover transition-all">
              <Phone className="w-7 h-7 text-gold mb-3" strokeWidth={1.5} /><p className="text-xs text-muted-foreground">Call Us</p><p className="font-semibold text-navy">{s.phone || "[Phone]"}</p>
            </a>
            <a href={waLink()} target="_blank" rel="noreferrer" data-testid="contact-whatsapp" className="p-6 rounded-2xl bg-white border border-gray-100 shadow-card hover:shadow-card-hover transition-all">
              <MessageCircle className="w-7 h-7 text-whatsapp mb-3" strokeWidth={1.5} /><p className="text-xs text-muted-foreground">WhatsApp</p><p className="font-semibold text-navy">Chat Now</p>
            </a>
            <a href={`mailto:${s.email}`} data-testid="contact-email" className="p-6 rounded-2xl bg-white border border-gray-100 shadow-card hover:shadow-card-hover transition-all">
              <Mail className="w-7 h-7 text-gold mb-3" strokeWidth={1.5} /><p className="text-xs text-muted-foreground">Email</p><p className="font-semibold text-navy break-all">{s.email || "[Email]"}</p>
            </a>
            <div className="p-6 rounded-2xl bg-white border border-gray-100 shadow-card">
              <Clock className="w-7 h-7 text-gold mb-3" strokeWidth={1.5} /><p className="text-xs text-muted-foreground">Business Hours</p><p className="font-semibold text-navy text-sm">{s.business_hours || "Mon - Sat: 9:30 AM - 7:00 PM"}</p>
            </div>
          </div>
          <div className="p-6 rounded-2xl bg-muted border border-gray-100 flex items-start gap-3">
            <MapPin className="w-6 h-6 text-gold shrink-0 mt-0.5" strokeWidth={1.5} />
            <div><p className="text-xs text-muted-foreground">Office Address</p><p className="font-semibold text-navy">{s.address || "[Office Address]"}</p></div>
          </div>
          <div className="rounded-2xl overflow-hidden border border-gray-100"><iframe title="office-map" src={mapSrc} className="w-full h-64 border-0" loading="lazy" referrerPolicy="no-referrer-when-downgrade" /></div>
        </div>

        <div className="bg-white rounded-2xl border border-gray-100 shadow-card p-8 h-fit">
          <h2 className="font-display text-2xl text-navy mb-1">Book a Consultation</h2>
          <p className="text-sm text-muted-foreground mb-5">Fill in your details and our advisor will get back to you.</p>
          <LeadForm variant="full" leadType="consultation" sourcePage="contact" />
        </div>
      </section>
    </div>
  );
}
